import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title
);

const PieChart = ({ data, title }) => {

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                text: title,
                font: {
                    size: 24,
                },
                color: '#fff',
            },
            legend: {
                position: 'bottom',
                labels: {
                    color: '#fff',
                    font: {
                        size: 16,
                    },
                },
            }, datalabels: {
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 16,
                },
                formatter: (value, context) => {
                    const data = context.chart.data.datasets[0].data;
                    const total = data.reduce((acc, val) => acc + val, 0);
                    const percentage = ((value / total) * 100).toFixed(1);
                    return ``;
                },
            },
        },
    };

    return (
        <div className='graph'>
            <Pie data={data} options={options} />
        </div>
    );
};

export default PieChart;
